const domain_info = {
	/* --------------------------- DOMAIN INFO SECTION -------------------------- */
	cancel_button: "Löschung von Domain",

	/* ------------------------------ CANCEL DIALOG ----------------------------- */
	cancel_dialog: {
		description:
			"Zur Bestätigung bitten wir Sie, den Domainnamen <strong>{{domain_name}}</strong> in das untenstehende Eingabefeld einzugeben.",
		info: "Nach der Kündigung bleibt Ihre Domain bis zum <strong>{{renewal_date}}</strong> aktiv. Nach diesem Datum verfällt der Domainname. Bitte beachten Sie! Die Kündigung einer Domain ist endgültig.",
		success_message: "Ihr Domainname wurde erfolgreich gekündigt.",
		title: "Löschung von Domainnamen",
		validation_input: {
			label: "Domainname eingeben",
			placeholder: "Domainname eingeben",
		},
	},
	/* ----------------------------- MANAGE SECTION ----------------------------- */
	manage: {
		add_button: "Eine Domain registrieren",
		table: {
			details: "Einzelheiten",
			dns: { button: "An DNS", title: "DNS" },
			domain_name: "Domainname",
			holder: "Halterung",
			price: "Preis",
			registration_date: "Datum der Registrierung",
			renewal_date: "Datum der Verlängerung",
			status: {
				active: "Aktiv",
				cancellation_pending: "Stornierung ausstehend",
				cancelled: "Abrufbar unter",
				error: "Gescheitert",
				in_progress: "In Arbeit",
				obsolete: "Veraltet",
				title: "Abonnement",
			},
		},
		title: "Verwalten",
	},
	tiles: {
		autorenew_tile: {
			bttn: "Automatische Erneuerung einschalten",
			description: "Status der automatischen Erneuerung",
			dialog: {
				description:
					"Sind Sie sicher, dass Sie die automatische Erneuerung für <strong>{{domain_name}}</strong> aktivieren möchten?",

				messages: {
					success: "Automatische Erneuerung aktiviert für <strong>{{domain_name}}</strong>",
				},
				title: "Automatische Erneuerung des Domainnamens",
			},
			state: ["Behinderte", "Aktiv"],
			title: "Automatische Erweiterung",
		},
		contact_tiles: {
			admin: "Administrativer Kontakt",
			billing: "Rechnungsstellung Kontakt",
			tech: "Technischer Kontakt",
		},
		debtor_tile: {
			business: "Business",
			company_name: "Name des Unternehmens",
			debtor_code: "Schuldner-Code",
			name: "Name",
			private: "Privatperson",
			title: "Schuldner",
		},
		holder_tile: {
			address: "Adres",
			change_holder: "Anderen Halter auswählen",
			coc_number: "Handelsregisternummer",
			company_name: "Name des Unternehmens",
			email_address: "E-Mail Adresse",
			first_name: "Vornamen",
			last_name: "Nachname",
			middle_name: "zweiter Vorname",
			phone_number: "Rufnummer",
			salutation: "Begrüßung",
			title: "Halterung",
			vat_number: "USt-IdNr",
		},
		info_tile: {
			authorization_code: {
				button: "Abrufen von Token",
				no_token: "Prüfen Sie Ihre E-Mail auf den Berechtigungscode",
				title: "Berechtigungscode (Token)",
			},
			auto_renew_date: "Datum der Verlängerung",
			dns_sec: { button: "DNSsec öffnen", title: "DNSsec" },
			expire_date: "Datum der Verfügbarkeit",
			local_presence: {
				tip: "Tooltip Stellvertreter",
				title: "Stellvertreter",
				true: "Im Einsatz",
			},
			price: {
				tip: "Der Preis bei der Erneuerung kann geringfügig variieren.",
				title: "Aktueller Preis",
			},
			registration_date: "Datum der Registrierung",
			title: "Informationen zum Bereich",
		},
		nameserver_tile: {
			change_ns_group: "Änderung NS-Gruppe",
			nameserver: "Nameserver",
			title: "Nameservers",
			used_nameservers_for_domain: "Die folgenden Nameserver werden für die Domain(s) verwendet:",
		},
		oxxa_error_tile: {
			description:
				"(Nur für Superuser) \n Es scheint, dass im Moment keine Verbindung zu Oxxa hergestellt werden kann. Dies ist erforderlich, um bestimmte Informationen über Domaininhaber anzuzeigen. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie einen Entwickler.",
			domain_info_not_available:
				"Achtung! Die folgenden Informationen konnten nicht aktualisiert werden. Die folgenden Informationen sind möglicherweise nicht aktuell.",
			mismatch_on_identities:
				"Bitte beachten Sie: Die unten aufgeführten Informationen zum Halter stimmen möglicherweise nicht überein. Wenden Sie sich bitte an den Tuxis-Support.",
		},
	},

	/* ----------------------------- TRANSFER DIALOG ---------------------------- */
	transfer_dialog: {
		cancel_checkbox: {
			label: "Diese Domain kündigen bis <strong>{{date}}</strong>",
			tooltip:
				"Ein Domainname muss 30 Tage vor dem Verlängerungsdatum gekündigt werden. Andernfalls wird er für das folgende Jahr in Rechnung gestellt",
		},
		description:
			"Wenn der Code auf der aktuellen Seite nach der Anfrage nicht sichtbar ist, wird er an die folgende E-Mail-Adresse geschickt:\n<strong>{{email_address}}</strong>",
		error_messages: {
			cancel_domain:
				"Achtung! Der Domainname MUSS vor {{date}} umgezogen werden, sonst wird er bis {{expire_date}} <strong>freigegeben</strong> und kann von Dritten registriert werden!",
			renewal_date:
				"Der Domainname muss vor dem <strong>{{date}}</strong> umgezogen sein, sonst wird diese Domain verlängert und in Rechnung gestellt.",
			unknown:
				"Bei der Anforderung des Umzugscodes ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an unsere Support-Abteilung.",
		},
		success_message:
			"Der Umzugscode wurde erfolgreich an die E-Mail-Adresse des Domaininhabers gesendet.",
		title: "Einen Umzugscode anfordern",
	},
};

export default domain_info;
